export default __webpack_public_path__ + "static/media/lc-icon.5fbbd1e0.svg";